import { CountrySubjectStore } from '@/store/Dictionary/CountrySubject'
import { CountriesStore } from '@/store/Dictionary/Countries'

export class DictionaryStore {
  countries = new CountriesStore()
  countrySubject = new CountrySubjectStore()
}
